import { useState } from 'react';
import styles from './ContactPage.module.css';
import appStyles from './App.module.css';

const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xlgovgep';

export default function ContactPage({ onBackHome }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setSubmitting(true);
    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ name, email, message }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        const msg = typeof data.error === 'string' ? data.error : data.errors?.[0]?.message;
        throw new Error(msg || 'Something went wrong. Please try again.');
      }
      setSuccess(true);
      setName('');
      setEmail('');
      setMessage('');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className={styles.contactPage} aria-labelledby="contact-heading">
      <h1 id="contact-heading" className={styles.title}>
        Contact &amp; feedback
      </h1>
      <p className={styles.lead}>
        Questions, corrections, or ideas? Send a note — we read every message.
      </p>

      {success && (
        <p className={styles.success} role="status">
          Thanks — your message was sent. We&apos;ll get back to you when we can.
        </p>
      )}
      {error && (
        <p className={styles.error} role="alert">
          {error}
        </p>
      )}

      <form className={styles.form} onSubmit={handleSubmit} noValidate>
        <div className={styles.field}>
          <label htmlFor="contact-name" className={styles.label}>
            Name
          </label>
          <input
            id="contact-name"
            name="name"
            type="text"
            className={styles.input}
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoComplete="name"
            required
            disabled={submitting}
          />
        </div>
        <div className={styles.field}>
          <label htmlFor="contact-email" className={styles.label}>
            Email
          </label>
          <input
            id="contact-email"
            name="email"
            type="email"
            className={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            required
            disabled={submitting}
          />
        </div>
        <div className={styles.field}>
          <label htmlFor="contact-message" className={styles.label}>
            Message
          </label>
          <textarea
            id="contact-message"
            name="message"
            className={styles.textarea}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            disabled={submitting}
            rows={6}
          />
        </div>
        <div className={styles.actions}>
          <button
            type="submit"
            className={`${appStyles.primaryButton} ${styles.submit}`}
            disabled={submitting}
          >
            {submitting ? 'Sending…' : 'Send message'}
          </button>
          {onBackHome && (
            <button type="button" className={styles.back} onClick={onBackHome}>
              Back to home
            </button>
          )}
        </div>
      </form>
    </section>
  );
}
